import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import Preloader from '../../Components/Preloader';
import Complaint_Policy_Seo from '../../SEO/Complaint_Policy_Seo';


function Complaint_Policy() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Simulate an asynchronous operation (e.g., fetching data)
        setTimeout(() => {
            setIsLoading(false);
        }, 500); // Simulating a 1-second delay
        // Sticky Menu and Scroll-to-Top
        const handleScroll = () => {
            const scroll = window.scrollY;
            const stickyHeader = document.getElementById('sticky-header');
            const scrollToTarget = document.querySelector('.scroll-to-target');

            if (scroll < 245) {
                stickyHeader?.classList.remove('sticky-menu');
                scrollToTarget?.classList.remove('open');
            } else {
                stickyHeader?.classList.add('sticky-menu');
                scrollToTarget?.classList.add('open');
            }
        };

        window.addEventListener('scroll', handleScroll);

        // thmSwiperInit definition
        const thmSwiperInit = () => {
            console.log('Swiper initialized');
        };

        thmSwiperInit();

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div>
            {isLoading ? (
                <Preloader />
            ) : (
                // Your actual content when not loading
                <div>
                    <Complaint_Policy_Seo/>
                    {/* back to top start */}
                    <button className="scroll-top scroll-to-target" data-target="html" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                        <i className="fa-solid fa-angles-up" />
                    </button>
                    <div className="">
                        <Header />
                        <section id="site-breadcumb" style={{ backgroundImage: 'url("assets/images/breadcumb/breadcumb-bd.svg")' }}>
                            <div className="site-breadcumb-wrapper">
                                <div className="container">
                                    <div className="row">
                                        <div className="col">
                                            <div className="breadcumb-content">
                                                <h1 className="breadcumb-title">Complaint Policy</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* Complaint Policy section start */}
                        <section className="service-details sec-ptb">
                            <div className="container">
                                <div className="row flex-column-reverse flex-xl-row">
                                    <div className="col-xl-12">
                                        <div className="service-details-wrapper">
                                            <div className="service-details-content">
                                                <div className="info-part">
                                                    <h4>Our complaints policy</h4>
                                                    <p className="mb-2">
                                                    We are committed to providing a high-quality money transfer service to all our clients. When something goes wrong, we need you to tell us about it. This will help us to improve our standards.
                                                    </p>
                                                    <p className='mb-4'>
                                                    If you have a complaint, please contact us with the details.
                                                    </p>
                                                </div>
                                                <div className="info-part">
                                                    <h4>Definitions</h4>
                                                    <ul className='info-list mb-4'>
                                                        <li>
                                                        By Email: <NavLink to="mailto:info@pay-quik.com">info@pay-quik.com</NavLink>
                                                        </li>
                                                        <li>
                                                        By Phone: <NavLink to="tel:447766431049">+44 7766 431 049</NavLink>
                                                        </li>
                                                        <li>
                                                        By Post: <NavLink to="https://www.google.com/maps/search/?api=1&query=167-169+Great+Portland+Street,+5th+Floor,+London+W1W+5PF" target='_blank'> 167-169 Great Portland Street, 5th Floor, London W1W 5PF.</NavLink>
                                                        </li>
                                                    </ul>
                                                    <p className='mb-4'>
                                                    We have eight weeks to consider your complaint. If we have not resolved it within this time you may complain to the Financial Ombudsman Service.
                                                    </p>
                                                </div>
                                                <div className="info-part">
                                                    <h4>What will happen next?</h4>
                                                   <ul className='info-list mb-4'>
                                                    <li>
                                                    We will send you a letter/email acknowledging receipt of your complaint on the same day of receiving it, enclosing a copy of this procedure. If you have complained in person or on call, we will try to resolve and reach the solution the same day.
                                                    </li>
                                                    <li>
                                                    If we are unable to resolve your complaint on the same day then we will further investigate your complaint. This will normally involve finding details of your complaint, reviewing your matter by speaking to the member of staff who acted for you.
                                                    </li>
                                                    <li>
                                                    We will respond to you within 7 days with our Final Response which may be a remedial action.
                                                    </li>
                                                    <li>
                                                    If you are still not satisfied, you can then contact the Financial Ombudsman Service, about your complaint. Normally, you will need to bring a complaint to the Financial Ombudsman Service within six months of receiving a final written response from us about your complaint. For further information, you should contact the Financial Ombudsman Service on: 
                                                    <ul>
                                                        <li>
                                                        Online: <NavLink to="https://www.financial-ombudsman.org.uk/" target='_blank'>https://www.financial-ombudsman.org.uk/</NavLink>
                                                        </li>
                                                        <li>
                                                        Email: <NavLink to="mailto:complaint.info@financial-ombudsman.org.uk">complaint.info@financial-ombudsman.org.uk</NavLink> ,
                                                        </li>
                                                        <li>
                                                        Mail: The Financial Ombudsman Service Exchange Tower, London, E14 9SR
                                                        </li>
                                                        <li>
                                                        Phone: <NavLink to="tel:08000234567">0800 023 4 567</NavLink> (free), <NavLink to="tel:03001239123">0300 123 9 123</NavLink>, weekdays from 8:00am - 8:00pm (GMT), and on Saturday from 9:00 - 1:00pm (GMT).
                                                        </li>
                                                        <li>
                                                        By Post: <NavLink to="https://www.google.com/maps/search/?api=1&query=167-169+Great+Portland+Street,+5th+Floor,+London+W1W+5PF" target='_blank'> 167-169 Great Portland Street, 5th Floor, London W1W 5PF.</NavLink>
                                                        </li>
                                                    </ul>
                                                    </li>
                                                    <li>
                                                    If you're not in the UK, call <NavLink to="tel:447766431049">+44 7766 431 049</NavLink>.
                                                    </li>
                                                   </ul>
                                                   <p className='mb-4'>
                                                   FOS will not charge you for making a complaint and if you are not satisfied with the outcome you can still bring legal proceedings. In addition, please note that disputes may also be submitted for online resolution via the European Online Dispute Resolution Platform accessible at: <NavLink to="http://ec.europa.eu/odr" target='_blank'>http://ec.europa.eu/odr</NavLink>
                                                   </p>
                                                </div>
                                               
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Complaint Policy section end */}

                        <Footer />
                    </div>
                </div>
            )}

        </div>
    )
}

export default Complaint_Policy
